import {AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {TtsControlEnum} from '@core/enums/tts-control.enum';

@Component({
    selector: 'app-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements AfterViewInit {
    @Input() tabindex: number;
    @Input() ariaLabel: string;
    @Input() disabled: boolean;
    @Input() cssClasses: string;
    @Input() icon: string;
    @Input() iconSize: '16' | '20' | '28' | '36' | '60' | '80';
    @Input() iconAdditionalClass: string;
    @Input() iconColor: 'purple-07' | 'blue-07' | 'blue-08' | 'blue-10' | 'gray-06' | 'gray-07' | 'gray-08' | 'red-06' | 'red-07';
    @Input() labelColor: 'purple-07' | 'blue-07' | 'blue-08' | 'gray-08' | 'red-07';
    @Input() hideLabelMobileOnly: boolean;
    @Input() hideLabel: boolean;
    @Input() additionalText: string;
    @Input() iconState: TtsControlEnum;
    @Input() customIcon: string;
    @Input() active: boolean | undefined;
    @Input() overIconText: string | undefined;
    @Input() basicMode: boolean;
    @Output() buttonClicked = new EventEmitter<void>();
    playIcon = 'record_voice_over';
    pauseIcon = 'pause';
    basicPlayIcon = 'play_arrow';

    @ViewChild('buttonElement') buttonElement: ElementRef;

    ngAfterViewInit(): void {
        this.buttonElement.nativeElement.addEventListener('keydown', (event: KeyboardEvent) => {
            if (event.key === 'Enter' || event.code === 'Space') {
                event.preventDefault();
            }
        });
        this.buttonElement.nativeElement.addEventListener('keyup', (event: KeyboardEvent) => {
            if (event.key === 'Enter' || event.code === 'Space') {
                this.buttonClicked.emit();
            }
        });
    }
}
